<template>
    <div style="height:100%">
        <div class="home-wrap" v-if="homeVisible">
            <!-- 空狀態 v-if="Object.keys(rulerObj).length == 0"-->
            <empty-state
                    v-if="Object.keys(rulerObj).length == 0"
                    :big-tip="$t('edit.ruler.rulerInfoNull')"
                    :small-tip="$t('edit.ruler.clickAddRuler')"
            >
                <a-button type="primary" @click="addRuler">{{$t('edit.ruler.addRuler')}}</a-button>
            </empty-state>

            <!-- 列表 -->
            <edit-drawer v-else :title="$t('edit.ruler.currentSceneRuler')">
                <template>
                    <ruler-list
                            v-for="(value,index) in rulerObj"
                            :item-obj="value"
                            :key="index"
                            :select-id="currRulerId"
                            @renameItem="renameItem"
                            @deleteItem="deleteItem"
                            @editItem="editItem"
                            @click.native="onClickItem(value)"
                    ></ruler-list>
                    <p class="tips"><a-icon type="exclamation-circle" />{{$t('edit.ruler.dragWhileEditing')}}</p>
                </template>
                <template #bottom>
                    <a-button type="primary" class="edit-default-btn full" @click="addRuler">{{$t('edit.ruler.addRuler')}}</a-button>
                </template>
            </edit-drawer>
        </div>
        <!-- 編輯標尺 -->
        <RulerSetting
                v-if="settingVisible"
                :target-obj="editRuler"
                @clickBack="clickBack"
                @saveChangeData="saveRuler"
        >
        </RulerSetting>

        <!--重命名-->
        <a-modal
                v-model="renameVisible"
                :title="$t('actionTitles.rename')"
                :destroyOnClose="true"
                @ok="handleConfirm"
                dialogClass="new-modal"
        >
            <template #closeIcon><img src="../../assets/img/modal_close_gray.png"/></template>
            <a-input v-model="newName" :addonBefore="$t('edit.name')" :placeholder="newName"></a-input>
        </a-modal>
    </div>
</template>

<script>
    import EmptyState from "../EmptyState";
    import EditDrawer from "../EditDrawer";
    import RulerList from "./RulerList";
    import RulerSetting from "./RulerSetting";
    import { mapGetters } from "vuex";

    export default {
        name: "index",
        components: {
            EmptyState,
            EditDrawer,
            RulerList,
            RulerSetting
        },
        data() {
            return {
                homeVisible: true,
                rulerObj: {},
                currRulerId: '',
                settingVisible: false,
                editRuler:null,
                renameVisible: false,
                newName: "",
                renameObj: {},
                kr: null
            }
        },
        computed: { ...mapGetters(["vrbase", "currentScenesId", "userInfo"]) },
        watch: {
            currentScenesId() {
                this.rulerObj = this.vrbase.scenes[this.currentScenesId].ruler;
                this.homeVisible = true
                this.settingVisible = false
                this.currRulerId = ''
            },
        },
        created() {
            this.rulerObj = this.vrbase.scenes[this.currentScenesId].ruler
            this.kr = document.getElementById('krpanoSWFObject');
        },
        methods: {
            //添加標尺
            addRuler(){
                this.editRuler = null
                this.homeVisible = false
                this.settingVisible = true
            },
            //保存標尺
            saveRuler({ key, data }) {
                let vrbase = this.vrbase;
                this.$set(this.rulerObj, key, data); // 更新本地
                this.$set(vrbase.scenes[this.currentScenesId].ruler,key,data)
                this.$store.dispatch("setVRBase", vrbase);
                this.$store.dispatch("saveVRBase", {vrbase, showLoading: true}).then(res=>{
                    setTimeout(()=>{
                        this.settingVisible = false
                        this.homeVisible = true
                    },1000)
                });
            },
            onClickItem(item) {
                this.currRulerId = item.hotspot_mark.name;
                if(item.hotspot_desc.ath == 0 && item.hotspot_desc.atv == 0){
                    lookto(item.hotspot_mark.point[0].ath,item.hotspot_mark.point[0].atv);
                }else{
                    lookto(item.hotspot_desc.ath,item.hotspot_desc.atv);
                }
            },
            //編輯
            editItem(item) {
                this.editRuler = item
                this.homeVisible = false
                this.settingVisible = true
            },
            //重命名
            renameItem(item) {
                this.renameObj = item;
                this.newName = item.title;
                this.renameVisible = true;
            },
            //重命名保存
            handleConfirm() {
                let item = this.vrbase.scenes[this.currentScenesId].ruler[
                    this.renameObj.hotspot_mark.name
                    ];
                this.$set(item, "title", this.newName);
                if(item.is_show_title == 1){
                    let txt = this.newName + item.length + item.unit
                    this.$set(item.hotspot_desc,'txt',txt)
                }
                this.$store.dispatch("setVRBase", this.vrbase);
                this.renameVisible = false;
                this.newName = "";
                this.renameObj = {};
            },
            //刪除
            deleteItem(item) {
                let ruler = this.vrbase.scenes[this.currentScenesId].ruler;
                krMarkLine.krpano_obj = this.kr;
                krMarkLine.hotspot_mark.name = item.hotspot_mark.name
                krMarkLine.delete()
                this.$delete(ruler, item.hotspot_mark.name);
                this.$delete(this.rulerObj, item.hotspot_mark.name);
                this.$store.dispatch("setVRBase", this.vrbase);
            },
            //返回編輯
            clickBack() {
                this.settingVisible = false;
                this.homeVisible = true;
            },
        }
    }
</script>

<style lang="less" scoped>
.tips{
    padding: 5px 16px 16px 16px;
    font-size: 12px;
    color: #939393;
    /deep/ .anticon{
        margin-right: 2px;
        color: #CE1414;
    }
}
.addRulerBtn {
    background-color: #7101ad;
    border-color: #7101ad;
}
.addRulerBtn:hover {
    background-color: #c65dff;
    border-color: #c65dff;
}
</style>
